module.exports = __webpack_public_path__ + "img/Item8light.60a87e24.svg";